import { WorksheetImagesAndRemarksSection, WorksheetTestedBySection } from 'Components/Worksheets/Core';
import { ListFieldSection, PageSection, SectionGroup } from '../../../Layout';
import ids from '../../QestIds';

import { NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import {
  CompactionCwdSection,
  CompactionDataSection,
  CompactionEquipmentSection,
  CompactionWaterContentDeterminationEquipmentSection,
  TestFractionSpecificGravitySection,
} from '../Shared';
import {
  CompactionWaterContentDeterminationGridSection,
  OversizeCorrectionSection,
  OversizeDeterminationSection,
  PreparationSection,
  ResultsSection,
} from './Sections';

const qestIds = [ids.maximumDryDensity.AASHTO_T99.rev2015, ids.maximumDryDensity.AASHTO_T180.rev2015];

let AashtoMddWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PreparationSection />
      <OversizeDeterminationSection />
      <NamePrefixModifier appendNamePrefix="Preparation.SpecificGravityCoarse">
        <OversizeCorrectionSection />
      </NamePrefixModifier>

      <NamePrefixModifier appendNamePrefix="TestFractionSpecificGravity">
        <TestFractionSpecificGravitySection />
      </NamePrefixModifier>

      <PageSection heading="Compaction">
        <CompactionEquipmentSection />
        <SectionGroup heading="Compaction Data">
          <CompactionCwdSection />
          <ListFieldSection name="TestPortions" /* for messages relating to test portions */ />
          <CompactionDataSection />
        </SectionGroup>
        <SectionGroup heading="Moisture Content Determination">
          <CompactionWaterContentDeterminationEquipmentSection />
          <CompactionWaterContentDeterminationGridSection />
        </SectionGroup>
      </PageSection>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <ResultsSection />
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AashtoMddWorksheet.qestIds = qestIds;

export default AashtoMddWorksheet;
